import React from 'react';
import ReactDOM from 'react-dom';
import Doc from './doc';

ReactDOM.render(<Doc />, document.getElementById('root'));
